export default __webpack_public_path__ + "static/media/hisky-logo.7b931eaa.svg";